<template>
  <v-container fluid>
    <v-progress-circular v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
      <v-snackbar
          v-model="snackbar"
          bottom
          :timeout="timeout"
          :color="color"
          >
          {{ text }}
    </v-snackbar>

    <!-- Kartica ide u dijalog, popis ostaje iza njega, pa se sljedeci partner
         otvara jednim klikom bez vracanja na popis. -->
    <v-dialog v-model="showCard2" scrollable max-width="1600" transition="dialog-bottom-transition">
      <v-card v-if="showCard2">
        <v-card-title class="os-dijalog-naslov">
          <span>{{ imeOtvorenog }}</span>
          <v-spacer></v-spacer>
          <v-btn icon aria-label="Zatvori karticu" @click="showCard2 = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <MainLedgerCard2 :items="dItems" :head="mainledgerAna"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showCard2 = false">Zatvori</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="os">
      <div class="os-head">
        <div class="os-firma">
          <div class="os-firma-ime">{{ comp.CompanyNameShort }}</div>
          <div>{{ comp.CompanyStreet }} {{ comp.CompanyBuildingNameNumber }}</div>
          <div>{{ comp.CompanyPostcode }} {{ comp.CompanyCity }}</div>
          <div>OIB: {{ comp.CompanyVATID }}</div>
        </div>
        <div class="os-naslov">
          <h2>{{ headUp }}</h2>
          <div class="os-meta">
            po dospijeću<span class="os-sep">·</span>konta {{ head.fromAccount }}–{{ head.toAccount }}<template v-if="head.BusinessYear"><span class="os-sep">·</span>poslovna godina {{ head.BusinessYear }}</template>
          </div>
        </div>
        <div class="os-akcije">
          <v-btn small outlined color="primary" @click="print">Printaj</v-btn>
          <v-btn small outlined @click="downloadFile">Excel</v-btn>
        </div>
      </div>

      <div class="os-sazetak">
        <div class="os-kut">
          <span>Partnera</span>
          <b>{{ prikazPartnera.length }}</b>
          <small>na popisu</small>
        </div>
        <div v-for="r in razredi" :key="r.k" class="os-kut" :class="{'os-lose': r.k === 'TotalOver'}">
          <span>{{ r.naziv }}</span>
          <b>{{ formatPrice(zbroj[r.k]) }}</b>
          <small>{{ postotak(zbroj[r.k]) }} % ukupnog</small>
        </div>
        <div class="os-kut os-istaknuto">
          <span>Ukupno otvoreno</span>
          <b>{{ formatPrice(zbroj.sve) }}</b>
          <small>{{ currency }}</small>
        </div>
      </div>

      <div class="os-alati">
        <span class="os-oznaka">Traži</span>
        <input v-model="trazi" class="os-trazi" type="search" placeholder="naziv ili OIB" aria-label="Traži partnera">
        <span class="os-broj">{{ prikazPartnera.length }} {{ oblik(prikazPartnera.length, 'partner', 'partnera', 'partnera') }} · klik na partnera otvara njegovu karticu</span>
      </div>

      <div v-if="!prikazPartnera.length" class="os-prazno">
        Nema otvorenih stavaka na kontima {{ head.fromAccount }}–{{ head.toAccount }}.
      </div>
      <div v-else class="os-scroll">
        <table class="os-tbl">
          <thead>
            <tr>
              <th class="l"><button type="button" @click="sortiraj('ime')">Partner<span class="os-smjer">{{ strelica('ime') }}</span></button></th>
              <th><button type="button" @click="sortiraj('konto')">Konto<span class="os-smjer">{{ strelica('konto') }}</span></button></th>
              <th v-for="r in razredi" :key="r.k"><button type="button" @click="sortiraj(r.k)">{{ r.kratko }}<span class="os-smjer">{{ strelica(r.k) }}</span></button></th>
              <th><button type="button" @click="sortiraj('sve')">Ukupno<span class="os-smjer">{{ strelica('sve') }}</span></button></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in prikazPartnera" :key="'b' + p.line" class="os-klik" tabindex="0" @click="navigateTo(p)" @keydown.enter="navigateTo(p)">
              <td class="os-partner-celija">
                <b>{{ p.partnerName || 'Bez OIB-a partnera' }}</b>
                <small>{{ p.partnerVATID }}</small>
              </td>
              <td class="num">{{ p.account4 }}</td>
              <td v-for="r in razredi" :key="r.k" class="num" :class="{nula: !broj(p[r.k]), neg: r.k === 'TotalOver' && broj(p[r.k]) > 0}">{{ broj(p[r.k]) ? formatPrice(broj(p[r.k])) : '–' }}</td>
              <td class="num">{{ formatPrice(ukupnoRedka(p)) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>UKUPNO {{ currency }}<span v-if="trazi.trim()" class="os-napomena"> · samo pronađeni partneri</span></td>
              <td></td>
              <td v-for="r in razredi" :key="r.k" class="num">{{ formatPrice(zbroj[r.k]) }}</td>
              <td class="num">{{ formatPrice(zbroj.sve) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
      <MainLedgerPrintCard9 ref="prnt" :card="card" :head="mainledgerAna" />
  </v-container>
</template>

<script>
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
//import PartnerService from '@/services/PartnerService'
import MainLedgerPrintCard9 from './MainLedgerPrintCard9'
import MainLedgerCard2 from './MainLedgerCard2'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import {mnozina, n2} from './otvoreneStavke'
import { domacaValuta } from '@/snippets/domacaValuta'
import xlsx from 'json-as-xlsx'
import dayjs from 'dayjs'

// Razredi dospijeca kako ih server vec racuna za ovaj izvjestaj.
const RAZREDI_BANKA = [
  {k: 'Total30', kratko: 'Do 30 d'},
  {k: 'Total60', kratko: '30–60 d'},
  {k: 'Total90', kratko: '60–90 d'},
  {k: 'Total120', kratko: '90–120 d'},
  {k: 'TotalOver', kratko: 'Preko 120 d'}
]

export default {
  name: 'mainledgercard9',
  props: ['items', 'head', 'totals'],
  data () {
    return {
      headUp: '',
      headers: [ ],
      search: '',
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      comp: {},
      error: null,
      localError: false,
      newUser: {},
      size: 'sm',
      havePath: '',
      Total1: 0,
      Total2: 0,
      Total3: 0,
      Total4: 0,
      Total5: 0,
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      pItems: [],
      mainQuery2: {},
      partner: {},
      card: {},
      showCard3: false,
      showCard2: false,
      mainledgerAna: {},
      dItems: [],
      partners: [],
      currency: 'EUR',
      imeOtvorenog: '',
      trazi: '',
      sortK: 'sve',
      sortSmjer: -1
    }
  },
  components: {
    MainLedgerPrintCard9,
    MainLedgerCard2
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }
    if (this.$store.state.partnerStore) {
      this.partners = this.$store.state.partnerStore
    }
    const typePartner = this.head.fromAccount ? this.head.fromAccount.substr(0,2) : ''
    this.headUp = typePartner === '12' ? this.lang.OpenStateBuyers : this.lang.OpenStateSupp

    this.headers.push(
      {text: this.lang.detailId, value: 'line', width: '80px'},
      {text: this.lang.Account4, value: 'account4', width: '100px',sortable: true,},
      {text: this.lang.PartnerName, value: 'partnerName', width: '300px', sortable: true,},
      {text: this.lang.PartnerVATID, value: 'partnerVATID', width: '100px', sortable: true,},
      {text: this.lang.Total30, value: 'Total30', align: 'right', sortable: true,},
      {text: this.lang.Total60, value: 'Total60', align: 'right', sortable: true, },
      {text: this.lang.Total90, value: 'Total90', align: 'right', sortable: true,},
      {text: this.lang.Total120, value: 'Total120', align: 'right', sortable: true,},
      {text: this.lang.TotalOver, value: 'TotalOver', align: 'right', sortable: true,}
    )

    this.PrintDate = dayjs(new Date()).format('DD.MM.YYYY, H:mm')
    this.currency = domacaValuta(this.$store.state.businessYear)
    this.comp = this.$store.state.companyActiv ? this.$store.state.companyActiv : {}
    
    this.card = {...this.head}
    this.card.items = this.items
    this.card.Total30 = this.totals.Total30
    this.card.Total60 = this.totals.Total60
    this.card.Total90 = this.totals.Total90
    this.card.Total120 = this.totals.Total120
    this.card.TotalOver = this.totals.TotalOver
  },
  computed: {
    razredi () {
      // Nazivi razreda ostaju iz prijevoda, kratice su za uske stupce.
      return RAZREDI_BANKA.map(r => ({k: r.k, kratko: r.kratko, naziv: this.lang[r.k] || r.kratko}))
    },
    prikazPartnera () {
      const t = this.trazi.trim().toLowerCase()
      const sve = Array.isArray(this.items) ? this.items : []
      const lista = t
        ? sve.filter(p => String(p.partnerName || '').toLowerCase().indexOf(t) !== -1 ||
            String(p.partnerVATID || '').indexOf(t) !== -1)
        : sve
      const kljucevi = {
        ime: p => String(p.partnerName || ''),
        konto: p => String(p.account4 || ''),
        sve: p => this.ukupnoRedka(p)
      }
      RAZREDI_BANKA.forEach(r => { kljucevi[r.k] = p => this.broj(p[r.k]) })
      const kljuc = kljucevi[this.sortK] || kljucevi.sve
      const smjer = this.sortSmjer
      return [...lista].sort((a, b) => {
        const va = kljuc(a)
        const vb = kljuc(b)
        const c = typeof va === 'string' ? va.localeCompare(vb, 'hr') : va - vb
        return c * smjer || (a.line || 0) - (b.line || 0)
      })
    },
    // Podnozje i sazetak prate pretragu, kao i na ostalim popisima partnera.
    zbroj () {
      const z = {sve: 0}
      RAZREDI_BANKA.forEach(r => { z[r.k] = 0 })
      this.prikazPartnera.forEach(p => {
        RAZREDI_BANKA.forEach(r => { z[r.k] = n2(z[r.k] + this.broj(p[r.k])) })
      })
      RAZREDI_BANKA.forEach(r => { z.sve = n2(z.sve + z[r.k]) })
      return z
    }
  },
  methods: {
     print(){
      this.$refs.prnt.print()
    },
    broj (v) {
      const n = parseFloat(v)
      return isNaN(n) ? 0 : n
    },
    ukupnoRedka (p) {
      return n2(RAZREDI_BANKA.reduce((z, r) => z + this.broj(p[r.k]), 0))
    },
    oblik (n, jedan, dva, pet) {
      return mnozina(n, jedan, dva, pet)
    },
    postotak (v) {
      return this.zbroj.sve > 0 ? Math.round((v || 0) / this.zbroj.sve * 100) : 0
    },
    // Klik na isti stupac okrece smjer. Iznosi krecu od najveceg, partner od A.
    sortiraj (k) {
      if (this.sortK === k) {
        this.sortSmjer = -this.sortSmjer
        return
      }
      this.sortK = k
      this.sortSmjer = (k === 'ime' || k === 'konto') ? 1 : -1
    },
    strelica (k) {
      if (this.sortK !== k) { return '' }
      return this.sortSmjer > 0 ? '↑' : '↓'
    },
    // Klik na partnera otvara njegovu karticu (sva knjizenja na istim kontima i
    // u istom razdoblju), istu onu koju daje gumb Kartica partnera.
    async navigateTo (p) {
      if (!p || !p.partnerVATID) {
        this.text = 'Ove stavke nemaju OIB partnera, pa se ne mogu otvoriti kao kartica partnera.'
        this.color = 'orange darken-3'
        this.timeout = 5000
        this.snackbar = true
        return
      }
      this.imeOtvorenog = p.partnerName || 'Bez OIB-a partnera'
      const glava = JSON.parse(JSON.stringify(this.head))
      delete glava.subtype
      glava.type = 2
      glava.partnerVATID = p.partnerVATID
      if (p.partnerId) { glava.partnerId = p.partnerId } else { delete glava.partnerId }
      this.dItems = []
      this.saving = true
      try {
        const {data} = await MainLedgerDetailService.card(glava)
        this.dItems = data && data.documents ? data.documents : []
        this.mainledgerAna = glava
        this.showCard2 = true
      } catch (err) {
        this.text = 'Kartica nije otvorena: ' + (err && err.message ? err.message : err)
        this.color = 'red'
        this.snackbar = true
      }
      this.saving = false
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    close () {
      this.show = false
    },
    downloadFile () {
      const columns = [
        { label: this.lang.detailId, value: 'line' },
        { label: this.lang.Account4, value: 'account4' },
        { label: this.lang.PartnerName, value: 'partnerName' },
        { label: this.lang.PartnerVATID, value: 'partnerVATID' },
        { label: this.lang.Total30, value: 'Total30' },
        { label: this.lang.Total60, value: 'Total60' },
        { label: this.lang.Total90, value: 'Total90' },
        { label: this.lang.Total120, value: 'Total120' },
        { label: this.lang.TotalOver, value: 'TotalOver' },
      ]

      const currDate = dayjs().format('DD_MM_YYYY_HH_mm')      
      const content = this.items
      const settings = {
        sheetName: 'Partneri_otvoreno',
        fileName: 'Partneri_otvoreno_banka_' + currDate
      }
      xlsx(columns, content, settings)
    }

  
 
  },
  watch: {

  }
}
</script>

<!-- Isti izgled popisa partnera kao Svi part.otvoreno i Kartice svih partnera. -->
<style scoped src="./otvoreneStavke.css"></style>
